// What the browser sends Athena each turn.
//
// The API accepts at most 20 turns of up to 4000 characters each
// (routes/copilot.ts). The side panel keeps one conversation across
// pages, so it outgrows both: send the most recent turns, clip long
// replies, and drop the local greeting. The last turn is always the
// user's new message.

export const API_MAX_TURNS = 20;
export const API_TURN_MAX_LEN = 4000;

export interface HistoryMessage {
  id: number;
  role: 'user' | 'assistant';
  content: string;
}

export function toApiHistory(
  messages: readonly HistoryMessage[],
  starterId: number,
): { role: 'user' | 'assistant'; content: string }[] {
  const turns = messages
    .filter((m) => m.id !== starterId && m.content.trim().length > 0)
    .map((m) => ({ role: m.role, content: m.content.slice(0, API_TURN_MAX_LEN) }));
  return turns.slice(-API_MAX_TURNS);
}

/** In-app path for page context, or null when the API would reject it. */
export function pageContextPath(pathname: string): string | null {
  return /^\/[A-Za-z0-9/_.-]{0,199}$/.test(pathname) && !pathname.includes('//') ? pathname : null;
}
